import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from "./../DeleteSectionButton";
import LastUpdatedAt from "./../LastUpdatedAt";
import {
  TextInput,
  RichTextInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";

const MarketSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      "has text",
      "Article content is required",
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, "").length > 0
    ),
  market_size: Yup.string()
    .required("Market size is required"),
});

export default function MarketForm({
  pitch:{market_section={}}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(market_section === null) market_section = {};

  const defaultValues = {
    market_size: market_section.market_size || "",
    content: RichTextInput.createState(market_section.content),
  }
  const methods = useForm({
    resolver: yupResolver(MarketSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
      methods.setValue("market_size", market_section.market_size || "");
      methods.setValue("content", RichTextInput.createState(market_section.content || ""));
  }, [methods, market_section]);

  const onSubmit = values => {
    const { market_size, content } = values
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          market_section_attributes: {
            market_size,
            content: RichTextInput.contentForSave(content),
          }
        }
      }
    })
  }

  return(
    <div id="marketForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "400px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Market</label>
              <TextInput
                name="market_size"
                placeholder="Market size in USD"
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={market_section.id} sectionType="market"/>
            <LastUpdatedAt updatedAt={ market_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
